import { ComponentRendering, HtmlElementRendering } from '@sitecore-jss/sitecore-jss-react';

export const shouldPioritizeComponentResources = (
  sitecorePlaceholderData: Array<ComponentRendering | HtmlElementRendering>,
  componentName: string
): boolean => {
  const excludedComponentNames = [
    'BreadcrumbBar',
    'ProductSeoTags',
    'NextSteps',
    'ProductBreadcrumbBar',
    'NavigationBarAnchorComponent',
    'ProductModelNavigation',
  ];

  const onlyComponents = sitecorePlaceholderData.filter((obj) => 'componentName' in obj) as Array<ComponentRendering>;
  const filteredComponentsList = onlyComponents.filter((component) => !excludedComponentNames.includes(component.componentName));

  // First biggest component in browser viewport affecting LCP metric
  const isFirstComponent = filteredComponentsList.findIndex((component) => component.componentName === componentName) === 0;

  return isFirstComponent;
};
